import { render, staticRenderFns } from "./template_modal.vue?vue&type=template&id=740b4c9c&scoped=true&"
import script from "./template_modal.vue?vue&type=script&lang=js&"
export * from "./template_modal.vue?vue&type=script&lang=js&"
import style0 from "./template_modal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./template_modal.vue?vue&type=style&index=1&id=740b4c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740b4c9c",
  null
  
)

export default component.exports